import { Link, Navigate, useParams } from 'react-router-dom';

import { Button, Typography } from '@occc/ui-design-system';
import { Page } from '@occc-app/design-system';
import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';

import { StoredValueUpdateLoading } from './stored-value-update-loading.component';
import {
  getStoredValueUpdateBreadcrumbLinks,
  STORED_VALUE_UPDATE_PAGE_TITLE,
} from './stored-value-update-page.utils';

import { StoredValueConfigureFormContainer } from '../stored-value-configure-form/stored-value-configure-form.container';
import { routeCreator } from '../stored-value.utils';
import { useGetStoredValueProgramById } from '../../data-access/queries';

export const StoredValueUpdatePageContainer = () => {
  const { storedValueProgramId = '' } = useParams<{ storedValueProgramId: string }>();
  const chainId = useChainId();

  const {
    data: program,
    loading,
    error,
  } = useGetStoredValueProgramById({
    id: storedValueProgramId,
    chainId,
  });

  if (!storedValueProgramId) {
    return <Navigate to={routeCreator.list} replace />;
  }

  if (loading) {
    return <StoredValueUpdateLoading />;
  }

  if (error || !program) {
    return (
      <Page
        browserTabTitle={STORED_VALUE_UPDATE_PAGE_TITLE}
        pageHeaderProps={{ title: STORED_VALUE_UPDATE_PAGE_TITLE }}
        containerProps={{ variant: 'md' }}
      >
        <Typography paragraph>We could not load this stored value program.</Typography>
        <Button component={Link} to={routeCreator.list} variant='contained'>
          Back to Stored Values
        </Button>
      </Page>
    );
  }

  return (
    <OfferUpdatePageContainer
      offerId={program.discountingOffer.id}
      getBreadcrumbLinks={getStoredValueUpdateBreadcrumbLinks}
      pageTitle={STORED_VALUE_UPDATE_PAGE_TITLE}
      offerType={OfferType.StoredValue}
      ConfigureFormContainer={StoredValueConfigureFormContainer}
      isDesignTabHidden
      finallyRedirectTo={routeCreator.list}
    />
  );
};
